require "./svgs/gift"
require "./svgs/infinity"


styles += """


  [data-widget="CreateForum"] #AUTH_wrapper {
    padding: 1.5em 0;
  }
  [data-widget="CreateForum"] #AUTH_task {
    font-size: 32px;
    margin-bottom: 4px;
  }


  [data-widget="CreateForum"] .additional_info {
    font-size: 13px;
    color: white;
    opacity: 1;
    margin-top: 8px;
    text-shadow: none;
    font-weight: 600;
    position: absolute;
    width: 100%;
    top: 100%;
    margin-top: 12px;
    padding: 0 24px;
  }

  [data-widget="CreateForum"] .button_wrapper {
    display: flex; 
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
  }

  [data-widget="CreateForum"] .plan_button {
    background-color: #d45283;
    text-shadow: 0 2px 4px rgba(0,0,0,0.50);
    padding: 16px 32px;
    font-size: 17px;
    display: flex;
    align-items: center;
    font-weight: 700;
    height: 60px;
  }

  [data-widget="CreateForum"] .domain_hint {
    color: white;
    font-size: 28px;
    padding: 0 2px;  
  }

  [data-widget="CreateForum"] .forum_url {
    display: none;
  }

  @media (max-width: 580px) {
    [data-widget="CreateForum"] .domain_hint {
      font-size: 16px;
    }
  }
  @media (max-width: 530px) {
    [data-widget="CreateForum"] .domain_hint {
      display: none;
    }
    [data-widget="CreateForum"] .forum_url {
      display: block;
      font-weight: 600;
      color: white;
      font-size: 15px;
      word-break: break-all;
    }
  }


"""

window.CreateForum = ReactiveComponent
  displayName: 'CreateForum'

  render : -> 
    current_user = fetch('/current_user')

    auth = fetch('auth')

    return SPAN null if !current_user.logged_in?


    if !current_user.logged_in && !auth.form
      auth.form = 'create account'
      save auth


    loc = fetch('location')
    if loc.query_params.error 
      @local.errors = [decodeURIComponent(loc.query_params.error)]
      save @local 
      delete loc.query_params.error 
      save loc 

    hide_free = loc.query_params?.plan == 'premium'
    hide_paid = WINDOW_WIDTH() < 550 && !hide_free 

    plan_button_style = 
      opacity: if !current_user.logged_in then 0 else if !(@local.forum_name?.length > 0) then .7
      cursor: if !current_user.logged_in || !(@local.forum_name?.length > 0) then 'auto' else 'pointer'


    @local.forum_name ?= loc.query_params.forum


    region = fetch('/application').region


    eu = ['Europe', 'https://eu.consider.it/create_forum']
    ca = ['Canada', 'https://ca.consider.it/create_forum']
    us = ['U.S.', 'https://consider.it/create_forum']
    au = ['Australia', 'https://au.consider.it/create_forum']

    if region == 'US'
      alternatives = [eu, ca, au]
    else if region == 'CA'
      alternatives = [us, eu, au]
    else if region == 'EU'
      alternatives = [us, ca, au]
    else if region == 'AU'
      alternatives = [us, ca, eu]
    else 
      alternatives = []


    DIV null,

      DIV 
        style: 
          backgroundColor: "rgba(255,255,255,.5)"
          color: "black"
          width: 350
          margin: 'auto'
          borderRadius: 16
          padding: '12px 24px'
          marginTop: 48

        "You're creating a forum on our "
        B null, 
          "#{if region == 'CA' then 'Canadian' else region} server"
        ". Alternatives:"
        for alt in alternatives
          A
            style: 
              paddingLeft: 8
            href: alt[1]
            alt[0]


      if @local.show_payment_form
        ModalStripePayment
          create_forum_after_payment: @refs.forum_name.value 
          copy_from: if @local.copy_from then @local.copy_from
          cancel_payment: =>
            @local.show_payment_form = false 
            save @local


      if current_user.logged_in

        forums = fetch '/your_forums'
        hosted_previously = forums.hosted

        FORM 
          ref: 'create_forum_form'
          action: "/subdomain#{if screencasting() then '?skip_seeding=true' else ''}"
          method: 'POST'
          autoComplete: if screencasting() then "off"

          DIV 
            style: 
              paddingTop: 40
              paddingBottom: 12
              width: 'var(--SAAS_PAGE_WIDTH)'
              margin: 'auto'
              textAlign: 'center'

            H1 
              className: 'main_callout condensed'
              style: 
                marginBottom: 24

              'Give your new Forum a name'

            DIV 
              style: 
                paddingBottom: 10

              SPAN
                className: 'domain_hint'
                'https://'
              INPUT
                defaultValue: @local.forum_name
                type: 'text'
                name: 'subdomain'
                ref: 'forum_name'
                style: 
                  border: "1px solid #000000"
                  padding: '8px 16px'
                  fontSize: 20
                  margin: '0 8px'
                  boxShadow: '0 0 18px 0 rgba(162,98,162,0.50)'
                  outline: '1px solid #A262A2'
                onChange: (e) =>
                  @local.forum_name = e.target.value
                  @local.slugged_forum_name = @local.forum_name.toLowerCase().trim().replace(/\ /g, '-').replace(/[^\w-]/g, '')
                  save @local

              SPAN
                className: 'domain_hint'
                '.consider.it'     

            DIV 
              className: 'forum_url'
              style: 
                visibility: if !@local.forum_name then 'hidden'
              "https://#{@local.slugged_forum_name}.consider.it"



          if hosted_previously?.length > 0
            previous_forums = hosted_previously.slice() 
            previous_forums.unshift({id: '', name: ''})
            DIV 
              style: 
                margin: 'auto'
                maxWidth: 600
                textAlign: 'center'

              DIV 
                style: 
                  color: 'white'
                "Import configuration from a previous forum (optional)"

              SELECT
                name: 'copy_from'
                defaultValue: null 
                onChange: (e) => 
                  @local.copy_from = e.target.value
                  @local.copy_from_premium = e.target.selectedOptions[0].textContent.indexOf("Premium Forum") > -1
                  save @local 

                for hosted_forum in previous_forums
                  OPTION
                    value: hosted_forum.id
                    key: hosted_forum.id
                    "#{hosted_forum.name}#{if hosted_forum.plan > 0 then " *Premium Forum*" else ""}"
              if @local.copy_from_premium
                DIV 
                  style: 
                    marginTop: 14
                    fontSize: 14
                    color: 'white'

                  "The configuration of Premium features may not apply until or unless your new forum is upgraded to a Premium Forum."

          if @local.errors && @local.errors.length > 0
            DIV 
              style: 
                padding: "8px 16px"
                backgroundColor: 'rgba(255,255,255,.6)'
                color: '#513152'
                maxWidth: 600
                margin: 'auto'

              for error, idx in @local.errors
                DIV 
                  style: 
                    fontWeight: 500
                    marginTop: if idx != 0 then 10
                  "#{if idx == 0 then "Ooops! " else ""}#{error}"



          DIV 
            style: 
              textAlign: 'center'
              paddingTop: 48
            
            INPUT 
              type: 'hidden'
              name: 'authenticity_token' 
              value: arest.csrf()

            INPUT 
              type: 'hidden'
              name: 'plan' 
              plan: 0

            DIV 
              style: 
                display: 'flex'
                justifyContent: 'center'
                alignItems: 'center'


              if !hide_free
                DIV 
                  className: 'button_wrapper'

                  BUTTON 
                    disabled: if !current_user.logged_in && @local.forum_name?.length > 0 then true
                    className: 'big_button plan_button' 
                    style: plan_button_style

                    giftSVG
                      height: 28

                    SPAN 
                      style: 
                        marginLeft: 16
                      'Create a Free Forum'

                  DIV 
                    className: 'additional_info'

                    'Use as long as you want.'
                    BR null
                    'No participation limits.'
                    BR null
                    'Can be upgraded later.'
                    BR null
                    'No card needed.'

              if !hide_free && !hide_paid
                SPAN 
                  style: 
                    padding: '0 24px'
                    color: 'white'
                    fontWeight: 600
                  'or'

              if !hide_paid
                DIV 
                  className: 'button_wrapper'

                  BUTTON 
                    disabled: if !current_user.logged_in && @local.forum_name?.length > 0 then true 
                    style: plan_button_style
                    className: 'big_button plan_button'
                    onClick: (e) =>
                      e.preventDefault()
                      e.stopPropagation()

                      @local.show_payment_form = true 
                      save @local
                      

                    infinitySVG
                      height: 15

                    SPAN 
                      style: 
                        marginLeft: 12
                      'Create a Premium Forum'

                  DIV 
                    className: 'additional_info'

                    '$625 one-time fee to unlock data export, sign-up questions, and more.'





          DIV 
            style: 
              textAlign: 'center'
              padding: '110px 0 150px 0'

            DIV 
              style: 
                padding: 0
                color: 'white'
                fontSize: 14

              'By creating a forum, you are agreeing to the '

              A 
                treat_as_external_link: true
                style: 
                  color: 'white'
                href: '/docs/legal/standard_hosting_terms'
                target: '_blank'
                'Consider.it Forum Hosting Terms'

            DIV 
              style: 
                marginTop: 24

              A 
                href: '/pricing'
                style: 
                  color: 'white'
                  fontWeight: 700
                  textDecoration: 'underline'
                  marginLeft: if !hide_free && !hide_paid then -48

                'More info on plans'


      DIV 
        style: 
          #backgroundColor: 'white'
          padding: '0px 10px'

        if !current_user.logged_in 

          DIV 
            style: 
              paddingBottom: 80

            H1 
              className: 'main_callout condensed'
              style: 
                paddingTop: 24
                width: "var(--SAAS_PAGE_WIDTH)"
                margin: 'auto'
                textAlign: 'center'

              'To Create a Forum,'

   
            DIV 
              style: 
                paddingBottom: 10
                width: "var(--SAAS_PAGE_WIDTH)"
                margin: 'auto'
                textAlign: 'center'
                fontSize: 20
                color: 'white'
                fontWeight: 500

              'please introduce yourself first.'


            @drawAuth()


        if current_user.logged_in && current_user.is_super_admin
          A
            style: 
              opacity: .1
              marginTop: 40
            onClick: logout
            'Logout'


  componentDidMount: -> 
    @setFocus()
    @listenForSubmit()
  componentDidUpdate: -> 
    @setFocus()
    @listenForSubmit()

  setFocus: -> 
    if !@initialized && @refs.forum_name
      setTimeout =>
        @refs.forum_name.focus()
        @initialized = true 
      , 1

  listenForSubmit: -> 
    if !@initialized && @refs.create_forum_form
      @initialized = true
      @refs.create_forum_form.addEventListener 'submit', => 
        plausibleEvent?('New_Forum')





  drawAuth: -> 
    Auth
      no_modal: true
      naked: true
      disallow_cancel: true
      primary_color: primary_color()






/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/create_forum.coffee
 **/